module.exports = __webpack_public_path__ + "img/checkmark-person.4a7b2f0c.svg";